module.exports = __webpack_public_path__ + "static/media/tablet_bg.68a63d80.png";